import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import copy from 'clipboard-copy';
import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { addJsonLdArticle } from '../../../actions/JsonLdActions';
import { APP_BASE_URL } from '../../../define/env';
import { notify } from '../../../helpers/action';
import { propBool, propFunc, propShape, } from '../../../helpers/custom-prop-types';
import LeftComponent from './LeftComponent';
import RightComponent from './RightComponent';
const DocumentComponent = (props) => {
    const { document, favoriteLoading, hasFavorite, isClientUser, isGuestUser, onCreateFavorite, onDeleteFavorite, onSubmit, } = props;
    const { content, title } = document;
    const dispatch = useDispatch();
    // JSON-LD 追加
    useEffect(() => {
        var _a, _b;
        const jsonLd = {
            author: {},
            datePublished: document.displayFromAt,
            headline: document.title,
            image: ((_b = (_a = document.thumbnail) === null || _a === void 0 ? void 0 : _a.default) === null || _b === void 0 ? void 0 : _b.src)
                ? [document.thumbnail.default.src]
                : [],
            mainEntityOfPage: `${APP_BASE_URL}/document/${document.weightLevel}/${document.id}`,
        };
        dispatch(addJsonLdArticle(jsonLd));
    }, [document, dispatch]);
    const contents = useMemo(() => (content || '')
        .split('\n')
        .filter((v) => v)
        .map((value, index) => ({
        id: index,
        value,
    })), [content]);
    // share関連
    const onClickClip = useCallback((e) => {
        const { value } = e.currentTarget;
        copy(value).then(() => {
            notify('リンクをコピーしました');
        });
    }, []);
    return (_jsxs("div", Object.assign({ className: `document_container ${isGuestUser ? 'is-guest' : ''}` }, { children: [_jsx("h1", Object.assign({ className: 'title' }, { children: title })), _jsx("ul", Object.assign({ className: 'themes' }, { children: _jsx("li", Object.assign({ className: 'theme' }, { children: "\u304A\u5F79\u7ACB\u3061\u8CC7\u6599" })) })), _jsxs("div", Object.assign({ className: 'document_container_group' }, { children: [_jsx(LeftComponent, { contents: contents, document: document, hasFavorite: hasFavorite, isClientUser: isClientUser, isGuestUser: isGuestUser, loadingFavorite: favoriteLoading, onClickCopy: onClickClip, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, title: title }), _jsx(RightComponent, { contents: contents, document: document, hasFavorite: hasFavorite, isClientUser: isClientUser, isGuestUser: isGuestUser, loadingFavorite: favoriteLoading, onClickCopy: onClickClip, onCreateFavorite: onCreateFavorite, onDeleteFavorite: onDeleteFavorite, onSubmit: onSubmit, title: title })] }))] })));
};
DocumentComponent.propTypes = {
    document: propShape().isRequired,
    favoriteLoading: propBool().isRequired,
    hasFavorite: propBool().isRequired,
    isClientUser: propBool().isRequired,
    isGuestUser: propBool().isRequired,
    onCreateFavorite: propFunc().isRequired,
    onDeleteFavorite: propFunc().isRequired,
    onSubmit: propFunc().isRequired,
};
export default DocumentComponent;
